<!-- 排行 -->
<template>
  <div class="h-list">
    <div class="item">
      <h-title :text="'签约数量城市排行'" :specialType="'special'"></h-title>
      <ul class="city-list">
        <transition-group name="list" mode="out-in">
          <li class="city" v-for="item in signList" :key="item.id">
            {{item.name}}
          </li>
          <li class="city" v-if="signList.length >= 1 && signList.length < 2" :key="'one'"></li>
          <li class="city" v-if="signList.length >= 1 && signList.length < 3" :key="'two'"></li>
          <li class="city" v-if="signList.length >= 1 && signList.length < 4" :key="'three'"></li>
          <li class="city" v-if="signList.length >= 1 && signList.length < 5" :key="'four'"></li>
        </transition-group>
      </ul>
    </div>
    <div class="item">
      <h-title :text="'活跃城市排行'" :specialType="'special'"></h-title>
      <ul class="city-list">
        <transition-group name="list" mode="out-in">
          <li class="active-city" v-for="item in activeList" :key="item.id">
            {{item.name}}
          </li>
          <li class="city" v-if="activeList.length >= 1 && activeList.length < 2" :key="'one'"></li>
          <li class="city" v-if="activeList.length >= 1 && activeList.length < 3" :key="'two'"></li>
          <li class="city" v-if="activeList.length >= 1 && activeList.length < 4" :key="'three'"></li>
          <li class="city" v-if="activeList.length >= 1 && activeList.length < 5" :key="'four'"></li>
        </transition-group>
      </ul>
    </div>
  </div>
</template>

<script>
import HTitle from '@/components/common/hTitle'
export default {
  data () {
    return {
      signFlag: true,
      signList: [],
      activeFlag: true,
      activeList: [],
      timer1: null,
      timer2: null
    }
  },
  props: {
    signRankList: {
      type: Array,
      required: true
    },
    activeRankList: {
      type: Array,
      required: true
    }
  },
  components: {
    HTitle
  },
  watch: {
    signRankList (newVal, oldVal) {
      const that = this
      if (newVal.length > 0) {
        clearInterval(that.timer1)
        that.timer1 = null
        if (that.signRankList.length > 5) {
          that.signList = that.signRankList.slice(0, 5)
          that.timer1 = setInterval(() => {
            if (that.signFlag) {
              that.signList = that.signRankList.slice(5)
              that.signFlag = false
            } else {
              that.signList = that.signRankList.slice(0, 5)
              that.signFlag = true
            }
          }, 5000)
        } else {
          that.signList = that.signRankList
          console.log(that.signList)
        }
      }
    },
    activeRankList (newVal, oldVal) {
      const that = this
      if (newVal.length > 0) {
        clearInterval(that.timer2)
        that.timer2 = null
        if (that.activeRankList.length > 5) {
          that.activeList = that.activeRankList.slice(0, 5)
          that.timer2 = setInterval(() => {
            if (that.activeFlag) {
              that.activeList = that.activeRankList.slice(5)
              that.activeFlag = false
            } else {
              that.activeList = that.activeRankList.slice(0, 5)
              that.activeFlag = true
            }
          }, 5000)
        } else {
          that.activeList = that.activeRankList
        }
      }
    }
  }
}
</script>

<style lang='stylus' scoped>
.h-list
  width 100%
  display flex
  justify-content space-around
  align-items center
  .item
    flex 1
    display flex
    flex-direction column
    justify-content flex-start
    align-items center
    .city-list
      width 180px
      height 150px
      overflow hidden
      .city
        list-style none
        height 30px
        line-height 30px
        font-size 14px
        color #44F0FF
        margin-left 30px
        width 180px
        overflow hidden
        text-overflow ellipsis
        white-space nowrap
      .active-city
        list-style none
        height 30px
        line-height 30px
        font-size 14px
        color #44F0FF
        margin-left 30px
        width 180px
        overflow hidden
        text-overflow ellipsis
        white-space nowrap
.list-enter-active, .list-leave-active {
  transition: all .5s;
}
.list-enter, .list-leave-to
/* .list-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(-90px);
}
</style>



// WEBPACK FOOTER //
// src/components/common/hList.vue